export default __webpack_public_path__ + "static/media/landing-bg.64d7ac30.jpg";